export default "__VITE_ASSET__eez7ZZ$E__"